module.exports = __webpack_public_path__ + "static/media/bg_middle_tab3.17b9d26d.png";